import { LockOutlined, PhoneOutlined } from '@ant-design/icons'
import { Form, FormItem, Input, Submit } from '@formily/antd'
import { createForm } from '@formily/core'
import { Field } from '@formily/react'
import { Card, message, Tabs } from 'antd'
import { useState } from 'react'
import { getEnv } from "../../../helpers/mobx-easy-wrapper"
import headerLogo from '../../../images/headerLogo.png'
import { VerifyCode } from './VerifyCode'

const normalForm = createForm({
    validateFirst: true,
})

const phoneForm = createForm({
    validateFirst: true,
})

export default () => {
    const { apiFactory } = getEnv();
    const [code, setCode] = useState("");
    const [phone, setPhone] = useState("");
    const loginSubmit = async (values:any) => {
        try {
            const response = await apiFactory.authService.patentLogin(values.phone, values.verifyCode);
            if (response.status != 200) {
                message.error(response.data.message);
                return;
            }
            message.success("登录成功");
            window.location.href="/expert/home"
            // props.closeEvent();
            setTimeout(() => {
                window.location.reload();
            }, 600);
        } catch (error: any) {
            message.error(JSON.parse(error.request.response).message);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                background: '#eee',
                padding: '40px 0',
            }}
        >
            <Card style={{ width: 400,height: 450,padding: 40 }}>
                <div style={{marginBottom: 25}}>
                    <img src={headerLogo} style={{width: '100%'}}/>
                </div>
                <Tabs style={{ overflow: 'visible', marginTop: -10 }}>
                    <Tabs.TabPane key="1" tab="短信验证码" >
                        <Form
                            form={phoneForm}
                            layout="vertical"
                            size="large"
                            style={{paddingBottom:40}}
                            onAutoSubmit={data =>{window.location.href = '/expert/'}}
                        >
                            <Field
                                name="phone"
                                title=""
                                required
                                validator="phone"
                                decorator={[FormItem]}
                                component={[
                                    Input,
                                    {
                                        placeholder: '请输入手机号',
                                        prefix: <PhoneOutlined />,
                                    },
                                ]}
                            />
                            <Field
                                name="verifyCode"
                                title=""
                                required
                                reactions={(field) => {
                                    const phone = field.query('.phone')
                                    field.setComponentProps({
                                        readyPost: phone.get('valid') && phone.get('value'),
                                        phoneNumber: phone.get('value'),
                                    })
                                }}
                                decorator={[FormItem]}
                                component={[
                                    VerifyCode,
                                    {
                                        placeholder: '请输入6位验证码',
                                        prefix: <LockOutlined />,
                                    },
                                ]}
                            />
                            <Submit block size="large" onSubmit={loginSubmit}>
                                登录
                            </Submit>
                        </Form>
                    </Tabs.TabPane>
                </Tabs>
            </Card>
        </div>
    )
}